// extracted by mini-css-extract-plugin
module.exports = {"container":"BankDetails_container__3Hm1M","buttonsContainer":"BankDetails_buttonsContainer__2qOFS"};